/* ==========================================================================
   GemofU: the photo for the chosen colour
   Loaded site-wide from layout/theme.liquid.

   Forge fires its own image change when a colour is picked, but on the
   desktop gallery (every photo in a grid) nothing moves, and the frame from
   gou-v4.css sat on whichever photo came first. This script:

     - finds the photo linked to the selected variant in Shopify admin
       (Products > the product > the variant > image),
     - marks it .gou-active-media, which draws the maroon frame
       (gou-v4.css section 3), and clears the mark from every other photo,
     - brings it into view: first place in the desktop grid, or the current
       slide in the phone / quick view carousel.

   Colours with no linked photo show no frame, so a shopper is never shown
   the wrong colour as "selected".

   The parsed variant list is cached on the product-json node as
   _gouV4Variants. (It used to be _gouVariants, the same name gou-qty.js uses
   for its stock map, so whichever script ran second broke.)
   ========================================================================== */
(function () {
  'use strict';

  function scopes() {
    var out = [];
    document.querySelectorAll('.product-main-images').forEach(function (gallery) {
      for (var n = gallery.parentElement; n && n !== document.body; n = n.parentElement) {
        if (n.querySelector('script.product-json') && n.querySelector('#formVariantId, input[name="id"]')) {
          if (out.indexOf(n) === -1) out.push(n);
          return;
        }
      }
    });
    return out;
  }

  function variantsOf(scope) {
    var node = scope.querySelector('script.product-json');
    if (!node) return [];
    if (!Array.isArray(node._gouV4Variants)) {
      try { node._gouV4Variants = JSON.parse(node.textContent).variants || []; } catch (e) { node._gouV4Variants = []; }
    }
    return node._gouV4Variants;
  }

  function mark(scope, bringIntoView) {
    var gallery = scope.querySelector('.product-main-images');
    var input = scope.querySelector('#formVariantId') || scope.querySelector('input[name="id"]');
    if (!gallery || !input) return;

    var id = String(input.value);
    var variant = null;
    variantsOf(scope).forEach(function (v) { if (String(v.id) === id) variant = v; });
    var mediaId = variant && variant.featured_media && variant.featured_media.id;

    var slide = null;
    if (mediaId) {
      var media = gallery.querySelector('.product-media--' + mediaId);
      if (media) slide = media.closest('.image-slide') || media;
    }

    gallery.querySelectorAll('.gou-active-media').forEach(function (el) {
      if (el !== slide) el.classList.remove('gou-active-media');
    });
    if (!slide) return;
    if (!slide.classList.contains('gou-active-media')) slide.classList.add('gou-active-media');
    if (!bringIntoView) return;

    // Carousel (phone, quick view): go to that slide.
    var carousel = gallery.querySelector('.flickity-enabled');
    var flkty = carousel && window.Flickity && window.Flickity.data ? window.Flickity.data(carousel) : null;
    if (flkty && flkty.cells) {
      for (var i = 0; i < flkty.cells.length; i++) {
        if (flkty.cells[i].element === slide) {
          if (flkty.selectedIndex !== i) flkty.select(i);
          return;
        }
      }
      return;
    }
    // Grid (desktop): the photo moves to the first place, beside the colours.
    gallery.querySelectorAll('.gou-first-media').forEach(function (el) {
      if (el !== slide) el.classList.remove('gou-first-media');
    });
    slide.classList.add('gou-first-media');
  }

  function markAll(bringIntoView) {
    scopes().forEach(function (s) { mark(s, bringIntoView); });
  }

  // Forge sets #formVariantId and fires "change" on it once the new variant
  // is known, after it has fetched the refreshed swatches.
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches) return;
    if (t.matches('#formVariantId, input[name="id"]')) {
      setTimeout(function () { markAll(true); }, 30);
    }
  }, true);

  // Quick view drawer and re-rendered galleries arrive later.
  var timer = null;
  function start() {
    markAll(!!/[?&]variant=/.test(location.search));
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { markAll(false); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   GemofU: search shortcuts and the search dropdown
   - A search that is really a category, price or occasion ("necklace",
     "rings", "under 999", "bangles below 1000", "bridal", "gift") goes
     straight to that collection page, already filtered by price where one
     was typed, instead of a loose list of matches.
   - In the search drawer: popular searches while the box is empty, and a
     "Show ..." shortcut line above the results once the typed words match
     one of the shortcuts.
   ========================================================================== */
(function () {
  'use strict';

  var CATS = [
    [/^(necklaces?|neck ?laces?|neckless|nekless|neckpieces?)$/, '/collections/necklace', 'Necklaces'],
    [/^(ear ?rings?|earings?)$/, '/collections/earrings', 'Earrings'],
    [/^(ear ?studs?|studs?|stud ear ?rings?)$/, '/collections/ear-studs', 'Ear Studs'],
    [/^(bangles?|kadas?)$/, '/collections/bangles', 'Bangles'],
    [/^(bracelets?)$/, '/collections/bracelets', 'Bracelets'],
    [/^(rings?|finger ?rings?)$/, '/collections/rings', 'Rings'],
    [/^(maa?ng ?tikk?as?|tikk?as?)$/, '/collections/maang-tikka', 'Maang Tikka'],
    [/^(mangal ?sutr(a|am|as)|thaa?li)$/, '/collections/mangalsutra', 'Mangalsutra'],
    [/^(bridal( sets?| jewell?e?ry)?|wedding( jewell?e?ry)?)$/, '/collections/all/bridal', 'Bridal & wedding'],
    [/^(party ?wear)$/, '/collections/all/party-wear', 'Party wear'],
    [/^(daily ?wear|everyday( wear)?)$/, '/collections/all/daily-wear', 'Daily wear'],
    [/^(office ?wear)$/, '/collections/all/office-wear', 'Office wear'],
    [/^(temple( jewell?e?ry)?)$/, '/collections/all/temple', 'Temple jewellery'],
    [/^((ethnic|traditional)( jewell?e?ry)?)$/, '/collections/all/traditional', 'Traditional jewellery'],
    [/^(gifts?|gifting|gift ideas?)$/, '/collections/all/gift', 'Gift ideas'],
    [/^(handmade( jewell?e?ry)?)$/, '/collections/all/handmade-jewellery', 'Handmade'],
    [/^(all|everything|shop all|all products|jewell?e?ry)$/, '/collections/all', 'All jewellery']
  ];

  // Colour, stone, finish and style words, and the product tag each one
  // maps to (tags added to every product in October 2026).
  var ATTRS = [
    [/^(red|ruby red)$/, 'red', 'Red'], [/^ruby$/, 'ruby', 'Ruby'],
    [/^green$/, 'green', 'Green'], [/^emerald$/, 'emerald', 'Emerald'],
    [/^mint( green)?$/, 'mint-green', 'Mint green'],
    [/^(pink|rani pink)$/, 'pink', 'Pink'], [/^(blue|navy|sapphire)$/, 'blue', 'Blue'],
    [/^white$/, 'white', 'White'], [/^black$/, 'black', 'Black'],
    [/^(purple|violet)$/, 'purple', 'Purple'], [/^maroon$/, 'maroon', 'Maroon'],
    [/^peach$/, 'peach', 'Peach'], [/^yellow$/, 'yellow', 'Yellow'],
    [/^turquoise$/, 'turquoise', 'Turquoise'], [/^aqua(marine)?$/, 'aquamarine', 'Aquamarine'],
    [/^multi ?colou?r$/, 'multicolour', 'Multicolour'],
    [/^cz$/, 'cz', 'CZ'], [/^(ad|ad stone|american diamond)$/, 'ad-stone', 'AD stone'],
    [/^kemp$/, 'kemp', 'Kemp'], [/^pearls?$/, 'pearl', 'Pearl'],
    [/^moissanite$/, 'moissanite', 'Moissanite'], [/^diamond replica$/, 'diamond-replica', 'Diamond replica'],
    [/^(natural|raw) stone$/, 'natural-stone', 'Natural stone'],
    [/^gold ?plated$/, 'gold-plated', 'Gold plated'], [/^(antique|antique gold|matte)$/, 'antique-gold', 'Antique'],
    [/^(silver|rhodium|rhodium plated)$/, 'rhodium-plated', 'Silver-tone'], [/^rose ?gold$/, 'rose-gold', 'Rose gold'],
    [/^(chok?ers?|chockers?)$/, 'choker', 'Choker'], [/^(jhumk(a|as|i|is)|jimikki|jhimikki)$/, 'jhumka', 'Jhumka'],
    [/^chand ?balis?$/, 'chandbali', 'Chandbali'], [/^harams?$/, 'haram', 'Haram'],
    [/^pendants?$/, 'pendant', 'Pendant'], [/^temple$/, 'temple', 'Temple'], [/^bridal$/, 'bridal', 'Bridal']
  ];

  function matchCat(q) {
    for (var i = 0; i < CATS.length; i++) {
      if (CATS[i][0].test(q)) return CATS[i];
    }
    return null;
  }

  // Words -> [[tagHandle, label], ...], or null if any word is unknown.
  // Two-word attributes ("mint green", "rose gold", "ad stone") are tried
  // before single words.
  function attrTags(words) {
    var out = [], i = 0;
    while (i < words.length) {
      var found = null;
      for (var len = 2; len >= 1 && !found; len--) {
        if (i + len > words.length) continue;
        var phrase = words.slice(i, i + len).join(' ');
        for (var k = 0; k < ATTRS.length; k++) {
          if (ATTRS[k][0].test(phrase)) { found = [ATTRS[k][1], ATTRS[k][2], len]; break; }
        }
      }
      if (!found) return null;
      if (!out.some(function (x) { return x[0] === found[0]; })) out.push([found[0], found[1]]);
      i += found[2];
    }
    return out.length ? out : null;
  }

  function norm(q) {
    return String(q || '').toLowerCase()
      .replace(/₹|\brs\.?|\binr\b|\/-/g, ' ')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  // Returns { url, label } for a shortcut query, or null.
  function route(raw) {
    var q = norm(raw);
    if (!q) return null;
    var lte = null, gte = null, m;

    m = q.match(/(\d{2,5})\s*(?:-|to)\s*(\d{2,5})/);
    if (m) { gte = +m[1]; lte = +m[2]; q = q.replace(m[0], ' '); }
    if (lte === null) {
      m = q.match(/\b(?:under|below|less than|upto|up to|within|max|budget)\s*(\d{2,5})\b/);
      if (m) { lte = +m[1]; q = q.replace(m[0], ' '); }
    }
    if (gte === null) {
      m = q.match(/\b(?:above|over|more than|from|min|starting)\s*(\d{2,5})\b/);
      if (m) { gte = +m[1]; q = q.replace(m[0], ' '); }
    }
    q = q.replace(/\b(price|priced|for women|for ladies|jewell?e?ry items?|items?)\b/g, ' ')
         .replace(/\s+/g, ' ').trim();
    var hasPrice = lte !== null || gte !== null;
    if (gte !== null && lte !== null && gte > lte) { var t = gte; gte = lte; lte = t; }

    var url = null, label = null;
    if (!q) {
      if (!hasPrice) return null;
      url = '/collections/all'; label = 'All jewellery';
    } else {
      var hit = matchCat(q);
      if (hit) { url = hit[1]; label = hit[2]; }
      if (!url) {
        // "red earrings", "green ad bangles", "pearl jhumka necklace": the
        // last words name the category, the words before it are colours,
        // stones or finishes. Those become tag filters on the category page
        // (/collections/earrings/red), using the product tags.
        var words = q.split(' ');
        for (var n = Math.min(3, words.length - 1); n >= 1 && !url; n--) {
          var tail = matchCat(words.slice(words.length - n).join(' '));
          if (!tail || !/^\/collections\/(necklace|earrings|ear-studs|bangles|bracelets|rings|maang-tikka|mangalsutra|all)$/.test(tail[1])) continue;
          var tags = attrTags(words.slice(0, words.length - n));
          if (!tags) continue;
          url = tail[1] + '/' + tags.map(function (x) { return x[0]; }).join('+');
          label = tags.map(function (x) { return x[1]; }).join(' ') + ' ' + tail[2].toLowerCase();
          label = label.charAt(0).toUpperCase() + label.slice(1);
        }
      }
      if (!url) return null;
    }

    var params = [];
    if (gte !== null) params.push('filter.v.price.gte=' + gte);
    if (lte !== null) params.push('filter.v.price.lte=' + lte);
    if (hasPrice) params.push('sort_by=price-ascending');
    var priceText = '';
    if (gte !== null && lte !== null) priceText = ' ₹' + gte + '–₹' + lte;
    else if (lte !== null) priceText = ' under ₹' + lte;
    else if (gte !== null) priceText = ' from ₹' + gte;
    return { url: url + (params.length ? '?' + params.join('&') : ''), label: label + priceText };
  }
  window.GouSearchRoute = route;

  // A tag page ("/collections/bangles/black") can be empty. Those are
  // checked first, and an empty one falls back to the normal search.
  var checked = {};
  function hasProducts(url) {
    if (!/^\/collections\/[^/?]+\/[^?]+/.test(url)) return Promise.resolve(true);
    if (checked[url] !== undefined) return Promise.resolve(checked[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var ok = html.indexOf('product-loop__item') !== -1;
        checked[url] = ok;
        return ok;
      })
      .catch(function () { return true; });
  }

  function searchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product%2Cpage%2Carticle&gou_stay=1';
  }

  function go(q, replace) {
    var r = route(q);
    if (!r) return false;
    hasProducts(r.url).then(function (ok) {
      var dest = ok ? r.url : searchUrl(q);
      if (replace) window.location.replace(dest); else window.location.href = dest;
    });
    return true;
  }

  // Any search form: a shortcut query goes straight to its page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !route(input.value)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(input.value, false);
  }, true);

  // Arriving on the search page some other way (a link, the back button).
  if (/\btemplate-search\b/.test(document.body.className)) {
    var p = new URLSearchParams(window.location.search);
    var q0 = p.get('q');
    if (q0 && !p.get('gou_from') && !p.get('gou_stay')) go(q0, true);
  }

  /* ---- The search drawer ------------------------------------------------ */
  var POPULAR = [
    ['Necklaces', '/collections/necklace'],
    ['Temple jewellery', '/collections/all/temple'],
    ['Bangles', '/collections/bangles'],
    ['Earrings', '/collections/earrings'],
    ['Mangalsutra', '/collections/mangalsutra'],
    ['Mint green', '/search?q=mint+green&options%5Bprefix%5D=last&gou_stay=1'],
    ['Under ₹999', '/collections/all?filter.v.price.lte=999&sort_by=price-ascending'],
    ['Bridal', '/collections/all/bridal'],
    ['Rings', '/collections/rings'],
    ['Gifts', '/collections/all/gift']
  ];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function arm(box) {
    if (box.hasAttribute('data-gou-ps')) return;
    var input = box.querySelector('input[name="q"]');
    var results = box.querySelector('#predictive-search');
    if (!input || !results) return;
    box.setAttribute('data-gou-ps', '');

    var popular = document.createElement('div');
    popular.className = 'gou-ps-popular';
    popular.innerHTML = '<p class="gou-ps-popular__title">Popular searches</p><ul class="gou-ps-chips">' +
      POPULAR.map(function (x) {
        return '<li><a class="gou-ps-chip" href="' + x[1] + '">' + esc(x[0]) + '</a></li>';
      }).join('') + '</ul>';
    results.parentNode.insertBefore(popular, results);

    var shortcut = document.createElement('a');
    shortcut.className = 'gou-ps-shortcut';
    shortcut.hidden = true;
    results.parentNode.insertBefore(shortcut, results);

    function update() {
      var v = input.value.trim();
      popular.hidden = v.length > 0;
      var r = v ? route(v) : null;
      if (!r) { shortcut.hidden = true; return; }
      hasProducts(r.url).then(function (ok) {
        if (input.value.trim() !== v) return;
        if (!ok) { shortcut.hidden = true; return; }
        shortcut.href = r.url;
        shortcut.innerHTML = 'Show <strong>' + esc(r.label) + '</strong><span aria-hidden="true">→</span>';
        shortcut.hidden = false;
      });
    }
    input.addEventListener('input', update);
    input.addEventListener('focus', update);
    update();
  }

  function armAll() {
    document.querySelectorAll('#predictiveSearch').forEach(arm);
  }

  var t = null;
  function start() {
    armAll();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(armAll, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
